<section mat-dialog-title>
  <span>Edit Data Point</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<form
  (ngSubmit)="saveChanges()"
  [formGroup]="form"
>
  <mat-dialog-content>
    <div class="flex flex-col lg:flex-row">
      <label
        class="input-main-label"
        for="friendly-name"
      >
        Friendly data point name:
      </label>
      <mat-form-field
        class="input-main w-full lg:w-[404px]"
        appearance="outline"
      >
        <input
          id="friendly-name"
          type="text"
          formControlName="friendlyName"
          matInput
        />
        <mat-error>Form is not valid</mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-col lg:flex-row">
      <label
        class="input-main-label"
        for="name"
      >
        Data point name:
      </label>
      <mat-form-field
        class="input-main w-full lg:w-[404px]"
        appearance="outline"
      >
        <input
          id="name"
          type="text"
          [disabled]="true"
          formControlName="name"
          matInput
        />
      </mat-form-field>
    </div>
    <div class="flex flex-col lg:flex-row">
      <label
        class="input-main-label"
        for="attribute-type"
      >
        Attribute type:
      </label>
      <mat-form-field
        class="input-main w-full lg:w-[404px]"
        appearance="outline"
      >
        <input
          id="attribute-type"
          type="text"
          [disabled]="true"
          formControlName="attributeType"
          matInput
        />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="test-btn-cancel btn-transparent btn-medium font-bold mr-4"
      mat-dialog-close
    >
      CANCEL
    </button>
    <button
      type="submit"
      class="btn-green btn-medium font-bold"
      [disabled]="isLoading$ | async"
    >
      @if (isLoading$ | async){
        <mat-spinner
          class="mr-1"
          diameter="20"
        />
      }
      SAVE
    </button>
  </mat-dialog-actions>
</form>
